const AccountRoles = {
    CLUB_MANAGER: 'CLUB_MANAGER',
    ADMINISTRATOR: 'ADMINISTRATOR',
    TRAINER: 'TRAINER'
};

export default AccountRoles;
